import React, { useEffect, useRef, useState } from "react"
import classnames from "classnames"
import _, { toInteger } from "lodash"
import PropTypes from "prop-types"

import InputSearch from "../InputSearch"
import ButtonFixedVoice from "../../ButtonFixedVoice"
import ActionForm from "../../ActionForm"
import SpinnerLoad from "../../SpinnerLoad"
import BadgeFixedVoice from "../BadgeFixedVoice"
import ModernModal from "shared/components/ModernModal"
import Typograph from "../../../../../components/Typograph"

import styles from "./styles.css"

import iconPlus from "../../../../../assets/svg/fixed_voice_plus.svg"
import iconArrowDown from "../../../../../assets/svg/fixed_voice_dash_arrow_down.svg"
import iconArrowLeftDisabled from "../../../../../assets/svg/fixed_voice_dash_arrow_left_disabled.svg"
import iconArrowLeft from "../../../../../assets/svg/fixed_voice_dash_arrow_left.svg"
import iconArrowRightDisabled from "../../../../../assets/svg/fixed_voice_dash_arrow_right_disabled.svg"
import iconArrowRight from "../../../../../assets/svg/fixed_voice_dash_arrow_right.svg"

const TableFixedVoice = ({
  headers,
  records,
  actions,
  type,
  page,
  changePage,
  totalPages,
  loading,
  selectClient,
  searchPlaceholder,
  search,
  registrationNotAllowed,
  error,
  isClientNumber
}) => {
  const actionsRef = useRef()
  const [searchTerm, setSearchTerm] = useState("")
  const [isOpen, setIsOpen] = useState(false)
  const [modalOpen, setModalOpen] = useState({ show: false, action: "" })
  const [isModalOpen, setIsModalOpen] = useState({
    message: {},
    open: false
  })

  const onSearch = () => {
    search(searchTerm)
  }

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  const goToPreviousPage = () => {
    changePage((prevPage) => prevPage - 1)
  }

  const goToNextPage = () => {
    changePage((prevPage) => prevPage + 1)
  }

  const handleSearchCustomer = (event) => {
    setSearchTerm(event.target.value)
    changePage(1)
  }

  const onCloseModal = () => {
    setIsModalOpen({ ...isModalOpen, open: false })
  }

  const showMore = (message) => {
    setIsModalOpen({ ...isModalOpen, message, open: true })
  }

  useEffect(() => {
    const handler = (e) => {
      if (!actionsRef.current.contains(e.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handler)

    return () => {
      document.removeEventListener("mousedown", handler)
    }
  }, [])

  const onSelectClient = (item) => {
    const documentClient = _.get(item, "document", null)

    if (documentClient) {
      selectClient(item)
    }
  }

  const renderHeaders = (headersLabel) => {
    return (
      <tr>
        {headersLabel.map((value, index) => {
          return <th key={index}>{value}</th>
        })}
      </tr>
    )
  }

  const renderLine = (lineLabel, index) => {
    const column = Object.values(lineLabel)
    const columnKey = Object.keys(lineLabel)

    const status = _.get(lineLabel, "status", null)
    const statusIndex = _.indexOf(columnKey, "status")
    const obs = _.get(lineLabel, "obs", {})
    const obsIndex = _.indexOf(columnKey, "obs")
    const hasObs = obs.reason || obs.windowsPort || obs.fluxoDeTrabalho
    const fieldType = _.get(lineLabel, "type", null)
    const fieldTypeIndex = _.indexOf(columnKey, "type")
    const state = _.get(lineLabel, "estado", null)
    const stateIndex = _.indexOf(columnKey, "estado")
    const typeState = isClientNumber ? fieldType : state
    const typeIndex = isClientNumber ? fieldTypeIndex : stateIndex

    return (
      <tr
        key={index}
        onClick={() => onSelectClient(lineLabel)}
        className={index === records.length - 1 ? styles.last_child : ""}
      >
        {column.map((value, indexColumn) => {
          if (status && statusIndex === indexColumn) {
            return (
              <td key={indexColumn}>
                <BadgeFixedVoice type={status} data={_.capitalize(status)} />
              </td>
            )
          } else if (type === "ORDERS" && obsIndex === indexColumn) {
            return renderColumnObs(hasObs, obs, indexColumn)
          } else {
            return (
              <td key={indexColumn} className={styles.truncatedCell}>
                <div className={styles.tooltipWrapper}>
                  {typeof value === "string" && value.length > 15
                    ? `${_.capitalize(value.substring(0, 15))}...`
                    : typeState && typeIndex === indexColumn
                    ? value
                    : _.capitalize(value)}
                  {typeof value === "string" && value.length > 15 && (
                    <span className={styles.tooltip}>
                      {_.capitalize(value)}
                    </span>
                  )}
                </div>
              </td>
            )
          }
        })}
      </tr>
    )
  }

  const renderColumnObs = (hasObs, obs, indexColumn) => {
    if (!hasObs) {
      return <td key={indexColumn}></td>
    }

    return (
      <td key={indexColumn}>
        <span onClick={() => showMore(obs)} className={styles.read_more}>
          Ler mais
        </span>
      </td>
    )
  }

  return (
    <div>
      <div className={styles.table_container}>
        <div className={styles.search_box}>
          <InputSearch
            searchTerm={searchTerm}
            handleSearch={handleSearchCustomer}
            placeholder={searchPlaceholder}
            onSearch={() => onSearch()}
          />
          <div className={styles.button_container}>
            <div className={styles.button_padding}>
              <ButtonFixedVoice
                name={"Cadastrar venda"}
                icon={iconPlus}
                isDisabled={registrationNotAllowed}
                linkName={"new-sale"}
                className={styles.buttonClass}
                isOutline
              />
            </div>
            <div ref={actionsRef}>
              <ButtonFixedVoice
                name={"Ações"}
                icon={iconArrowDown}
                onAction={toggleDropdown}
                isRight
                isSecondary
              />
              {isOpen && (
                <div className={styles.dropdown_content}>
                  {actions.map((item, index) => (
                    <button
                      key={index}
                      onClick={() => setModalOpen({ show: true, action: item })}
                    >
                      {item}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.table_over}>
          {loading && (
            <div className={styles.loading}>
              <SpinnerLoad />
            </div>
          )}
          <table>
            <thead>{renderHeaders(headers)}</thead>
            <tbody>
              {!loading && !records.length > 0 ? (
                <tr className={styles.empty_message}>
                  <td>
                    Clientes ou Números não foram encontrados.
                    <span>{_.capitalize(error)}</span>
                  </td>
                </tr>
              ) : (
                records.map((item, index) => renderLine(item, index))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className={styles.pagination}>
        <button onClick={goToPreviousPage} disabled={page === 1}>
          {page === 1 ? (
            <img
              className={styles.previous_arrow}
              src={iconArrowLeftDisabled}
              alt={"arrow to the left"}
            />
          ) : (
            <img
              className={styles.previous_arrow}
              src={iconArrowLeft}
              alt={"arrow to the left"}
            />
          )}
          Anterior
        </button>
        <span className={styles.page_container}>
          {" "}
          <span className={styles.box_current_number}>{page} </span> de{" "}
          {totalPages}
        </span>
        <button
          onClick={goToNextPage}
          disabled={page === toInteger(totalPages)}
        >
          Próxima
          {page === toInteger(totalPages) ? (
            <img
              className={styles.next_arrow}
              src={iconArrowRightDisabled}
              alt={"arrow to the right"}
            />
          ) : (
            <img
              className={styles.next_arrow}
              src={iconArrowRight}
              alt={"arrow to the right"}
            />
          )}
        </button>
      </div>

      {modalOpen.show && (
        <ActionForm
          openForm={modalOpen.show}
          action={modalOpen.action}
          type={type}
          onCloseModal={() => {
            setModalOpen({ show: false, action: "" })
          }}
        />
      )}

      <ModernModal
        isOpen={isModalOpen.open}
        onClose={() => onCloseModal()}
        title={"Observação"}
        removeButton
        confirmButtonText="Fechar"
        onConfirm={() => onCloseModal()}
      >
        <div className={styles.content_children_obs}>
          <Typograph
            htmlTag="h1"
            size="medium"
            color="outer_space"
            weight="bold"
          >
            Observação
          </Typograph>
          <div className={styles.modal_details_obs}>
            {isModalOpen.message.windowsPort && (
              <div>
                <Typograph
                  htmlTag="span"
                  size="medium"
                  color="outer_space"
                  weight="bold"
                >
                  Data da janela:
                </Typograph>
                <Typograph
                  htmlTag="p"
                  size="medium"
                  color="outer_space"
                  weight="regular"
                >
                  {isModalOpen.message.windowsPort}
                </Typograph>
              </div>
            )}
            {isModalOpen.message.reason && (
              <div>
                <Typograph
                  htmlTag="span"
                  size="medium"
                  color="outer_space"
                  weight="bold"
                >
                  Motivo da interrupção:
                </Typograph>
                <Typograph
                  htmlTag="p"
                  size="medium"
                  color="outer_space"
                  weight="regular"
                >
                  {isModalOpen.message.reason}
                </Typograph>
              </div>
            )}
            {isModalOpen.message.fluxoDeTrabalho && (
              <div
                className={classnames({
                  [styles.alignClass]:
                    isModalOpen.message.fluxoDeTrabalho.length > 30
                })}
              >
                <Typograph
                  htmlTag="span"
                  size="medium"
                  color="outer_space"
                  weight="bold"
                >
                  Fluxo de trabalho:
                </Typograph>
                <Typograph
                  htmlTag="p"
                  size="medium"
                  color="outer_space"
                  weight="regular"
                >
                  {isModalOpen.message.fluxoDeTrabalho}
                </Typograph>
              </div>
            )}
          </div>
        </div>
      </ModernModal>
    </div>
  )
}

TableFixedVoice.propTypes = {
  headers: PropTypes.array,
  records: PropTypes.array,
  actions: PropTypes.array,
  type: PropTypes.string,
  page: PropTypes.number,
  changePage: PropTypes.func,
  totalPages: PropTypes.any,
  loading: PropTypes.bool,
  selectClient: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  search: PropTypes.func,
  registrationNotAllowed: PropTypes.bool,
  error: PropTypes.string,
  isClientNumber: PropTypes.bool
}

export default TableFixedVoice



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/TableFixedVoice/index.js